import axios from "axios";

export const getDataSources = async () => {
  const token = localStorage.getItem("token");
  const apiUrlDashboard = `${process.env.REACT_APP_API}data-sources`;

  if (!token) {
    throw new Error("No se encontró un token");
  }

  try {
    const response = await axios.get(apiUrlDashboard, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error en la solicitud:", error);
    throw error;
  }
};

export const createDataSource = async (
  channelNames,
  sourceType,
  vehicleName,
) => {
  const token = localStorage.getItem("token");
  const apiUrlDashboard = `${process.env.REACT_APP_API}data-sources`;

  if (!token) {
    throw new Error("No se encontró un token");
  }

  const requestBody = {
    channel_names: channelNames,
    source_type: sourceType,
    vehicle_name: vehicleName,
  };

  try {
    const response = await axios.post(apiUrlDashboard, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error en la solicitud:", error);
    throw error;
  }
};

export const updateDataSource = async (
  dataSourceId,
  channelNames,
  sourceType,
  vehicleName,
) => {
  const token = localStorage.getItem("token");
  const apiUrlDashboard = `${process.env.REACT_APP_API}data-sources/${dataSourceId}`;

  if (!token) {
    throw new Error("No se encontró un token");
  }

  const requestBody = {
    channel_names: channelNames,
    source_type: sourceType,
    vehicle_name: vehicleName,
  };

  try {
    const response = await axios.put(apiUrlDashboard, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error en la solicitud:", error);
    throw error;
  }
};

export const deleteDataSource = async (dataSourceId) => {
  const token = localStorage.getItem("token");
  const apiUrlDashboard = `${process.env.REACT_APP_API}data-sources/${dataSourceId}`;

  if (!token) {
    throw new Error("No se encontró un token");
  }

  try {
    await axios.delete(apiUrlDashboard, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    console.log("Data source deleted successfully");
    return { message: "Data source deleted successfully" };
  } catch (error) {
    console.error("Error en la solicitud:", error);
    throw error;
  }
};

export const getDataSourceById = async (dataSourceId) => {
  const token = localStorage.getItem("token");
  const apiUrlDashboard = `${process.env.REACT_APP_API}data-source/${dataSourceId}`;

  if (!token) {
    throw new Error("No se encontró un token");
  }

  try {
    const response = await axios.get(apiUrlDashboard, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error en la solicitud:", error);
    throw error;
  }
};
